export class ImportFormat {
    format: string;
    fileExtension: string;

    constructor(format: string, fileExtension: string | string[]) {
        this.format = format;

        if (Array.isArray(fileExtension)) {
            this.fileExtension = fileExtension.join(',');
        } else {
            this.fileExtension = fileExtension;
        }
    }

    // extensions
    static readonly ALL_EXTENSIONS = '*/*';
    static readonly CSV_EXTENSION = '.csv';
    static readonly XML_EXTENSION = '.xml';

    // file formats
    static readonly ALL_FORMATS: ImportFormat = new ImportFormat('', ImportFormat.ALL_EXTENSIONS);
    static readonly CSV_FORMAT: ImportFormat = new ImportFormat('CSV', ImportFormat.CSV_EXTENSION);
    static readonly XML_FORMAT: ImportFormat = new ImportFormat('XML', ImportFormat.XML_EXTENSION);
    static readonly EAD_45_FORMAT: ImportFormat = new ImportFormat('EAD AIXM 4.5', ImportFormat.XML_EXTENSION);
    static readonly EAD_51_FORMAT: ImportFormat = new ImportFormat('EAD AIXM 5.1', ImportFormat.XML_EXTENSION);
    static readonly NM_AIXM_FORMAT: ImportFormat = new ImportFormat('NM AIXM 5.1', '.baseline');
    static readonly ARINC_424_FORMAT: ImportFormat = new ImportFormat('ARINC 424', ['.pc', '.dat']);
    static readonly ZIP_FORMAT: ImportFormat = new ImportFormat('ZIP', '.zip');


    // entities formats
    static readonly LAYER_FORMATS: ImportFormat = new ImportFormat('SHP_KML', [".shp", ".kml", ".zip"]);

    static readonly SAAM_LAYER_FORMATS: ImportFormat = new ImportFormat('ARE', ".are");

    static readonly NAVAIDS_FORMATS: ImportFormat[] =
        [
            ImportFormat.CSV_FORMAT,
            ImportFormat.XML_FORMAT,
            ImportFormat.EAD_45_FORMAT,
            ImportFormat.EAD_51_FORMAT,
            ImportFormat.NM_AIXM_FORMAT,
            ImportFormat.ARINC_424_FORMAT,
            new ImportFormat('SAFIRE', '.xml'),
        ];

    static readonly COORD_POINTS_FORMATS: ImportFormat[] =
        [
            ImportFormat.XML_FORMAT,
            ImportFormat.EAD_45_FORMAT,
            ImportFormat.EAD_51_FORMAT,
            ImportFormat.NM_AIXM_FORMAT,
            ImportFormat.ARINC_424_FORMAT,
        ];
    static readonly PROCEDURES_FORMATS: ImportFormat[] =
        [
            ImportFormat.CSV_FORMAT,
            new ImportFormat('Import and Create Procedure from Route Segments - CSV', ImportFormat.CSV_EXTENSION),
            ImportFormat.XML_FORMAT,
            ImportFormat.EAD_45_FORMAT,
            ImportFormat.EAD_51_FORMAT,
            ImportFormat.NM_AIXM_FORMAT,
            ImportFormat.ARINC_424_FORMAT,
        ];

    static readonly AERODROMES_FORMATS: ImportFormat[] =
        [
            ImportFormat.EAD_45_FORMAT,
            ImportFormat.EAD_51_FORMAT,
            ImportFormat.NM_AIXM_FORMAT,
        ];

    static readonly FLIGHT_INSPECTION_FORMATS: ImportFormat[] =
        [
            ImportFormat.CSV_FORMAT,
            new ImportFormat('EDS', '.txt'),
            new ImportFormat('Aerodata', '.txt'),
        ];

    static readonly PROCESSING_TOOL_FORMATS: ImportFormat[] =
        [
            ImportFormat.CSV_FORMAT,
            new ImportFormat('Aerodata', '.txt'),
            new ImportFormat('EDS 300', '.txt'),
        ];

    static readonly ROUTE_SEGMENTS_FORMATS: ImportFormat[] =
        [
            ImportFormat.CSV_FORMAT,
            ImportFormat.EAD_45_FORMAT,
            ImportFormat.EAD_51_FORMAT,
        ];

    static readonly VERTEX_FORMATS: ImportFormat[] =
        [
            ImportFormat.CSV_FORMAT,
            ImportFormat.EAD_45_FORMAT,
            ImportFormat.EAD_51_FORMAT,
        ];

    static readonly RVT_KMZ_FORMATS: ImportFormat[] =
        [
            new ImportFormat('RVT', '.rtv'),
            new ImportFormat('KMZ', ImportFormat.ALL_EXTENSIONS),
        ];

    static readonly AIR_SPACE_BOUNDARIES_FORMATS: ImportFormat = ImportFormat.XML_FORMAT;

    static readonly OBSTACLE_DATA_FORMATS: ImportFormat = ImportFormat.CSV_FORMAT;
}